export default "__VITE_ASSET__CVC9hOde__"